import styled from 'styled-components';
import { UiColors } from 'assets/styles/old/global';
import { CLOSE_MODAL_ICON_WHITE } from 'assets/icons';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 4px 24px 4px 0;
`;

export const Title = styled.h3`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: ${UiColors.peachColor};
`;

export const Subtitle = styled.p`
  margin: 0 0 10px;
  font-size: 13px;
  opacity: 0.85;
  color: ${UiColors.peachColor};
`;

/* Scrolls rather than truncating: the point of the reminder is that the user can see
   everything they left unfinished, so a "+3 more" would defeat it. */
export const List = styled.ul`
  margin: 0;
  padding: 0 6px 0 0;
  list-style: none;
  max-height: 280px;
  overflow-y: auto;

  /* The default scrollbar renders light grey on the toast's dark background (--baltic-sea),
     which reads as a foreign element. Tint it with the toast's own text colour instead. */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 237, 220, 0.35) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 237, 220, 0.35);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 237, 220, 0.55);
  }
`;

export const Item = styled.li`
  & + & {
    margin-top: 2px;
  }
`;

/* A button, not an anchor: an <a href> would trigger a full page load, which resets the
   module-level `appAlreadyRunning` flag in pages/Survey and would put us back into the
   silent-restore path this feature deliberately avoids. */
export const DraftButton = styled.button`
  display: block;
  width: 100%;
  padding: 7px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: ${UiColors.peachColor};
  font-family: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:focus-visible {
    outline: 2px solid ${UiColors.peachColor};
    outline-offset: -2px;
  }
`;

export const DraftLabel = styled.span`
  display: block;
  text-decoration: underline;
  text-underline-offset: 2px;
`;

export const DraftMeta = styled.span`
  display: block;
  margin-top: 2px;
  font-size: 12px;
  opacity: 0.75;
`;

/* react-toastify's own close button is hidden globally
   (assets/styles/react-toastify.scss -> .Toastify__close-button { display: none }),
   so a toast that doesn't draw its own cannot be dismissed at all. */
export const CancelButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent url(${CLOSE_MODAL_ICON_WHITE}) no-repeat center center;
  background-size: 12px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${UiColors.peachColor};
    outline-offset: 2px;
  }
`;
